import { useSwiperSlide } from "swiper/react";

const QuoQuestLevelStageDateRange = ({
  dateFrom,
  dateTo
}: {
  dateFrom: Date;
  dateTo: Date;
}) => {
  const swiperSlide = useSwiperSlide();

  const generateDaysArray = (start: Date, end: Date) => {
    const arr: Date[] = [];
    for (
      let dt = new Date(start);
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 1)
    ) {
      arr.push(new Date(dt));
    }
    while (arr.length < 28) {
      const datePrior = new Date(
        new Date(arr[0]).setDate(arr[0].getDate() - 1)
      );
      const dateNext = new Date(
        new Date(arr[arr.length - 1]).setDate(arr[arr.length - 1].getDate() + 1)
      );
      arr.unshift(datePrior);
      arr.push(dateNext);
    }
    return arr;
  };

  return (
    <div className="relative overflow-hidden w-full h-10 shrink-0">
      <div
        className={`absolute left-1/2 ${
          swiperSlide.isActive ? "-translate-x-1/2" : "-translate-x-60"
        } flex transition-all duration-500`}
      >
        {generateDaysArray(dateFrom, dateTo).map(date => {
          const isInSideTimeframe = date >= dateFrom && date <= dateTo;
          const radius =
            date.getDate() === dateFrom.getDate()
              ? "rounded-l-[0.63rem]"
              : date.getDate() === dateTo.getDate()
              ? "rounded-r-[0.63rem]"
              : "";
          return (
            <div
              key={date.getTime()}
              className={`text-sm p-2 ${
                isInSideTimeframe
                  ? "text-secondary-50 bg-[#142757]"
                  : "text-primary-70"
              } ${radius}`}
            >
              {date.getDate()}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuoQuestLevelStageDateRange;
